"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePutSendAsProspectingBatchByIdMutation = exports.usePutScheduleProspectingBatchByIdMutation = exports.usePutSendProspectingBatchByIdMutation = exports.useCreateProspectingBatchMutation = exports.useUploadProspectingContactsFileMutation = exports.useCreateProspectingBatchGiftsByIdMutation = exports.usePutProspectingBatchMessagingByIdMutation = exports.usePutProspectingBatchDefaultProductByIdMutation = exports.useDeleteProspectingBatchByIdMutation = exports.useLazyGetProspectingContactsFileTemplateQuery = exports.useGetProspectingBatchEmailPreviewByIdQuery = exports.useGetProspectingBatchStatusByIdQuery = exports.useGetProspectingBatchGiftsByIdQuery = exports.useGetProspectingBatchByIdQuery = exports.useGetProspectingPartialBatchesQuery = exports.partialBatchesAdapter = exports.ProspectingBatchesTagType = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toolkit = require("@reduxjs/toolkit");

var _utils = require("@alycecom/utils");

var _EmptyAppApi = require("../../EmptyAppApi");

var _types = require("./types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ProspectingBatchesTagType;
exports.ProspectingBatchesTagType = ProspectingBatchesTagType;

(function (ProspectingBatchesTagType) {
  ProspectingBatchesTagType["Batch"] = "ProspectingBatchesTagType__Batch";
  ProspectingBatchesTagType["Gift"] = "ProspectingBatchesTagType__Gift";
})(ProspectingBatchesTagType || (exports.ProspectingBatchesTagType = ProspectingBatchesTagType = {}));

var partialBatchesAdapter = (0, _toolkit.createEntityAdapter)();
exports.partialBatchesAdapter = partialBatchesAdapter;

var prospectingBatches = _EmptyAppApi.emptyAppApi.enhanceEndpoints({
  addTagTypes: [ProspectingBatchesTagType.Batch, ProspectingBatchesTagType.Gift]
}).injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getProspectingPartialBatches: build.query({
        query: function query(params) {
          return "/api/v1/campaigns/prospecting/batches?".concat((0, _utils.queryParamsBuilder)(params));
        },
        providesTags: [{
          type: ProspectingBatchesTagType.Batch,
          id: 'PARTIAL-LIST'
        }]
      }),
      getProspectingBatchById: build.query({
        query: function query(_ref) {
          var batchId = _ref.batchId;
          return "/api/v1/campaigns/prospecting/batches/".concat(batchId);
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        },
        providesTags: function providesTags(result) {
          return result ? [{
            type: ProspectingBatchesTagType.Batch,
            id: result.id
          }] : [];
        },
        onQueryStarted: function () {
          var _onQueryStarted = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref2, _ref3) {
            var batchId, queryFulfilled, dispatch;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    batchId = _ref2.batchId;
                    queryFulfilled = _ref3.queryFulfilled, dispatch = _ref3.dispatch;
                    return _context.abrupt("return", queryFulfilled.then(function (_ref4) {
                      var data = _ref4.data;
                      dispatch(prospectingBatches.util.updateQueryData('getProspectingBatchById', {
                        batchId: batchId
                      }, function (draft) {
                        return _objectSpread(_objectSpread({}, draft), {}, {
                          meetingHosts: _objectSpread(_objectSpread({}, draft.meetingHosts), {}, {
                            ownerId: data.meetingHosts.ownerId === null ? 0 : data.meetingHosts.ownerId
                          })
                        });
                      }));
                    }));

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function onQueryStarted(_x, _x2) {
            return _onQueryStarted.apply(this, arguments);
          }

          return onQueryStarted;
        }()
      }),
      getProspectingBatchGiftsById: build.query({
        query: function query(_ref5) {
          var batchId = _ref5.batchId,
              params = _ref5.params;
          return "/api/v1/campaigns/prospecting/batches/".concat(batchId, "/gifts?").concat((0, _utils.queryParamsBuilder)(params));
        },
        providesTags: [{
          type: ProspectingBatchesTagType.Gift,
          id: 'PARTIAL-LIST'
        }]
      }),
      getProspectingBatchStatusById: build.query({
        query: function query(_ref6) {
          var batchId = _ref6.batchId;
          return "/api/v1/campaigns/prospecting/batches/".concat(batchId, "/status");
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        },
        onQueryStarted: function () {
          var _onQueryStarted2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(arg, _ref7) {
            var queryFulfilled, dispatch;
            return _regenerator["default"].wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    queryFulfilled = _ref7.queryFulfilled, dispatch = _ref7.dispatch;
                    return _context2.abrupt("return", queryFulfilled.then(function (response) {
                      if (response.data.created === response.data.total) {
                        dispatch(prospectingBatches.util.updateQueryData('getProspectingBatchById', {
                          batchId: arg.batchId
                        }, function (draft) {
                          return _objectSpread(_objectSpread({}, draft), {}, {
                            giftsCreationStatus: _types.ProspectingBatchGiftsStatus.Finished,
                            giftsTotal: response.data.total
                          });
                        }));
                      }
                    }));

                  case 2:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          function onQueryStarted(_x3, _x4) {
            return _onQueryStarted2.apply(this, arguments);
          }

          return onQueryStarted;
        }()
      }),
      getProspectingBatchEmailPreviewById: build.query({
        query: function query(_ref8) {
          var batchId = _ref8.batchId;
          return "/api/v1/campaigns/prospecting/batches/".concat(batchId, "/preview/email");
        },
        transformResponse: function transformResponse(response) {
          return response.data;
        }
      }),
      getProspectingContactsFileTemplate: build.query({
        query: function query() {
          return {
            url: "/api/v1/campaigns/prospecting/contacts/file-template?time=".concat(Date.now()),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            },
            responseHandler: function responseHandler(response) {
              return response.blob();
            }
          };
        },
        onQueryStarted: function () {
          var _onQueryStarted3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_arg, _ref9) {
            var queryFulfilled;
            return _regenerator["default"].wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    queryFulfilled = _ref9.queryFulfilled;
                    return _context3.abrupt("return", queryFulfilled.then(function (result) {
                      (0, _utils.downloadFile)(result.data, 'alyce_prospecting_contacts_upload_template.xlsx');
                    }));

                  case 2:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          function onQueryStarted(_x5, _x6) {
            return _onQueryStarted3.apply(this, arguments);
          }

          return onQueryStarted;
        }()
      }),
      deleteProspectingBatchById: build.mutation({
        query: function query(_ref10) {
          var batchId = _ref10.batchId;
          return {
            url: "/api/v1/campaigns/prospecting/batches/".concat(batchId),
            method: 'DELETE'
          };
        },
        transformResponse: function transformResponse(_response, _meta, arg) {
          return arg;
        },
        invalidatesTags: function invalidatesTags(result) {
          return result ? [{
            type: ProspectingBatchesTagType.Batch,
            id: result.batchId
          }] : [];
        }
      }),
      putProspectingBatchDefaultProductById: build.mutation({
        query: function query(_ref11) {
          var batchId = _ref11.batchId,
              body = _ref11.body;
          return {
            url: "/api/v1/campaigns/prospecting/batches/".concat(batchId, "/default-product"),
            method: 'PUT',
            body: body
          };
        },
        transformResponse: function transformResponse(_response, _meta, arg) {
          return arg;
        },
        onQueryStarted: function () {
          var _onQueryStarted4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref12, _ref13) {
            var batchId, body, dispatch, queryFulfilled, getProspectingBatchByIdPatch;
            return _regenerator["default"].wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    batchId = _ref12.batchId, body = _ref12.body;
                    dispatch = _ref13.dispatch, queryFulfilled = _ref13.queryFulfilled;
                    getProspectingBatchByIdPatch = dispatch(prospectingBatches.util.updateQueryData('getProspectingBatchById', {
                      batchId: batchId
                    }, function (draft) {
                      return _objectSpread(_objectSpread({}, draft), {}, {
                        defaultProduct: {
                          id: Number(body.id),
                          denomination: body.denomination
                        }
                      });
                    }));
                    queryFulfilled["catch"](getProspectingBatchByIdPatch.undo);

                  case 4:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          function onQueryStarted(_x7, _x8) {
            return _onQueryStarted4.apply(this, arguments);
          }

          return onQueryStarted;
        }(),
        invalidatesTags: [{
          type: ProspectingBatchesTagType.Batch,
          id: 'PARTIAL-LIST'
        }]
      }),
      putProspectingBatchMessagingById: build.mutation({
        query: function query(_ref14) {
          var _body$meetingHosts, _body$meetingHosts2;

          var batchId = _ref14.batchId,
              body = _ref14.body;
          return {
            url: "/api/v1/campaigns/prospecting/batches/".concat(batchId, "/messaging"),
            method: 'PUT',
            body: _objectSpread(_objectSpread({}, body), {}, {
              meetingHosts: _objectSpread(_objectSpread({}, body === null || body === void 0 ? void 0 : body.meetingHosts), {}, {
                ownerId: (body === null || body === void 0 ? void 0 : (_body$meetingHosts = body.meetingHosts) === null || _body$meetingHosts === void 0 ? void 0 : _body$meetingHosts.ownerId) === 0 ? null : body === null || body === void 0 ? void 0 : (_body$meetingHosts2 = body.meetingHosts) === null || _body$meetingHosts2 === void 0 ? void 0 : _body$meetingHosts2.ownerId
              })
            })
          };
        },
        transformResponse: function transformResponse(_response, _meta, arg) {
          return arg;
        },
        onQueryStarted: function () {
          var _onQueryStarted5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(_ref15, _ref16) {
            var batchId, body, dispatch, queryFulfilled, getProspectingBatchById;
            return _regenerator["default"].wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    batchId = _ref15.batchId, body = _ref15.body;
                    dispatch = _ref16.dispatch, queryFulfilled = _ref16.queryFulfilled;
                    getProspectingBatchById = dispatch(prospectingBatches.util.updateQueryData('getProspectingBatchById', {
                      batchId: batchId
                    }, function (draft) {
                      var _body$video, _body$video2, _body$video2$embed, _body$video3, _body$video3$vidyard, _body$video4, _body$video4$vidyard;

                      return _objectSpread(_objectSpread(_objectSpread({}, draft), body), {}, {
                        messaging: _objectSpread(_objectSpread({}, draft.messaging), body.message),
                        recipientActions: _objectSpread(_objectSpread({}, draft.recipientActions), body.recipientActions),
                        video: {
                          type: ((_body$video = body.video) === null || _body$video === void 0 ? void 0 : _body$video.type) || null,
                          embed: {
                            videoUrl: ((_body$video2 = body.video) === null || _body$video2 === void 0 ? void 0 : (_body$video2$embed = _body$video2.embed) === null || _body$video2$embed === void 0 ? void 0 : _body$video2$embed.videoUrl) || ''
                          },
                          vidyard: {
                            imageUrl: ((_body$video3 = body.video) === null || _body$video3 === void 0 ? void 0 : (_body$video3$vidyard = _body$video3.vidyard) === null || _body$video3$vidyard === void 0 ? void 0 : _body$video3$vidyard.imageUrl) || '',
                            videoUrl: ((_body$video4 = body.video) === null || _body$video4 === void 0 ? void 0 : (_body$video4$vidyard = _body$video4.vidyard) === null || _body$video4$vidyard === void 0 ? void 0 : _body$video4$vidyard.videoUrl) || ''
                          }
                        },
                        meetingHosts: draft.meetingHosts ? _objectSpread(_objectSpread({}, draft.meetingHosts), body.meetingHosts) : draft.meetingHosts
                      });
                    }));
                    queryFulfilled["catch"](getProspectingBatchById.undo);

                  case 4:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }));

          function onQueryStarted(_x9, _x10) {
            return _onQueryStarted5.apply(this, arguments);
          }

          return onQueryStarted;
        }(),
        invalidatesTags: [{
          type: ProspectingBatchesTagType.Batch,
          id: 'PARTIAL-LIST'
        }]
      }),
      createProspectingBatchGiftsById: build.mutation({
        query: function query(_ref17) {
          var batchId = _ref17.batchId;
          return {
            url: "/api/v1/campaigns/prospecting/batches/".concat(batchId, "/gifts"),
            method: 'PUT'
          };
        },
        transformResponse: function transformResponse(_response, _meta, arg) {
          return arg;
        },
        invalidatesTags: [{
          type: ProspectingBatchesTagType.Batch,
          id: 'PARTIAL-LIST'
        }],
        onQueryStarted: function () {
          var _onQueryStarted6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(arg, _ref18) {
            var queryFulfilled, dispatch, patchResult;
            return _regenerator["default"].wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    queryFulfilled = _ref18.queryFulfilled, dispatch = _ref18.dispatch;
                    patchResult = dispatch(prospectingBatches.util.updateQueryData('getProspectingBatchById', {
                      batchId: arg.batchId
                    }, function (draft) {
                      return _objectSpread(_objectSpread({}, draft), {}, {
                        giftsCreationStatus: _types.ProspectingBatchGiftsStatus.Pending
                      });
                    }));
                    _context6.prev = 2;
                    _context6.next = 5;
                    return queryFulfilled;

                  case 5:
                    _context6.next = 10;
                    break;

                  case 7:
                    _context6.prev = 7;
                    _context6.t0 = _context6["catch"](2);
                    patchResult.undo();

                  case 10:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, null, [[2, 7]]);
          }));

          function onQueryStarted(_x11, _x12) {
            return _onQueryStarted6.apply(this, arguments);
          }

          return onQueryStarted;
        }()
      }),
      uploadProspectingContactsFile: build.mutation({
        query: function query(_ref19) {
          var campaignId = _ref19.campaignId,
              body = _ref19.body;
          var formData = new FormData();
          formData.append('contacts', body.contacts);
          return {
            url: "/api/v1/campaigns/prospecting/".concat(campaignId, "/contacts/upload-file"),
            method: 'POST',
            body: formData
          };
        },
        transformResponse: function transformResponse(response) {
          var _response$data;

          return (_response$data = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data !== void 0 ? _response$data : response;
        }
      }),
      createProspectingBatch: build.mutation({
        query: function query(_ref20) {
          var campaignId = _ref20.campaignId,
              body = _ref20.body;
          return {
            url: "/api/v1/campaigns/prospecting/".concat(campaignId, "/batches"),
            method: 'POST',
            body: body
          };
        },
        transformResponse: function transformResponse(response) {
          var _response$data2;

          return (_response$data2 = response === null || response === void 0 ? void 0 : response.data) !== null && _response$data2 !== void 0 ? _response$data2 : response;
        },
        invalidatesTags: function invalidatesTags(result) {
          return (result === null || result === void 0 ? void 0 : result.giftBatchId) ? [{
            type: ProspectingBatchesTagType.Batch,
            id: 'PARTIAL-LIST'
          }] : [];
        }
      }),
      putSendProspectingBatchById: build.mutation({
        query: function query(_ref21) {
          var batchId = _ref21.batchId;
          return {
            url: "/api/v1/campaigns/prospecting/batches/".concat(batchId, "/gifts/send"),
            method: 'PUT'
          };
        },
        transformResponse: function transformResponse(_response, _meta, args) {
          return args;
        },
        invalidatesTags: [{
          type: ProspectingBatchesTagType.Batch,
          id: 'PARTIAL-LIST'
        }]
      }),
      putScheduleProspectingBatchById: build.mutation({
        query: function query(_ref22) {
          var batchId = _ref22.batchId,
              body = _ref22.body;
          return {
            url: "/api/v1/campaigns/prospecting/batches/".concat(batchId, "/gifts/schedule"),
            method: 'PUT',
            body: body
          };
        },
        transformResponse: function transformResponse(_response, _meta, args) {
          return args;
        },
        invalidatesTags: [{
          type: ProspectingBatchesTagType.Batch,
          id: 'PARTIAL-LIST'
        }]
      }),
      putSendAsProspectingBatchById: build.mutation({
        query: function query(_ref23) {
          var batchId = _ref23.batchId,
              targetSendAs = _ref23.targetSendAs;
          return {
            url: "/api/v1/campaigns/prospecting/batches/".concat(batchId, "/send-as-person"),
            method: 'PUT',
            body: {
              sendAsPersonId: targetSendAs === null || targetSendAs === void 0 ? void 0 : targetSendAs.id
            }
          };
        },
        transformResponse: function transformResponse(_response, _meta, args) {
          return args;
        },
        invalidatesTags: [{
          type: ProspectingBatchesTagType.Batch,
          id: 'PARTIAL-LIST'
        }],
        onQueryStarted: function () {
          var _onQueryStarted7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(_ref24, _ref25) {
            var batchId, targetSendAs, queryFulfilled, dispatch;
            return _regenerator["default"].wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    batchId = _ref24.batchId, targetSendAs = _ref24.targetSendAs;
                    queryFulfilled = _ref25.queryFulfilled, dispatch = _ref25.dispatch;
                    return _context7.abrupt("return", queryFulfilled.then(function () {
                      if (queryFulfilled) {
                        dispatch(prospectingBatches.util.updateQueryData('getProspectingBatchById', {
                          batchId: batchId
                        }, function (draft) {
                          return _objectSpread(_objectSpread({}, draft), {}, {
                            messaging: _objectSpread(_objectSpread({}, draft === null || draft === void 0 ? void 0 : draft.messaging), {}, {
                              sendAsPersons: [{
                                sendAsEmail: (targetSendAs === null || targetSendAs === void 0 ? void 0 : targetSendAs.email) || '',
                                contactsCount: 0,
                                hasIntegrationConnected: false
                              }]
                            })
                          });
                        }));
                      }
                    }));

                  case 3:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          }));

          function onQueryStarted(_x13, _x14) {
            return _onQueryStarted7.apply(this, arguments);
          }

          return onQueryStarted;
        }()
      })
    };
  }
});

var useGetProspectingPartialBatchesQuery = prospectingBatches.useGetProspectingPartialBatchesQuery,
    useGetProspectingBatchByIdQuery = prospectingBatches.useGetProspectingBatchByIdQuery,
    useGetProspectingBatchGiftsByIdQuery = prospectingBatches.useGetProspectingBatchGiftsByIdQuery,
    useGetProspectingBatchStatusByIdQuery = prospectingBatches.useGetProspectingBatchStatusByIdQuery,
    useGetProspectingBatchEmailPreviewByIdQuery = prospectingBatches.useGetProspectingBatchEmailPreviewByIdQuery,
    useLazyGetProspectingContactsFileTemplateQuery = prospectingBatches.useLazyGetProspectingContactsFileTemplateQuery,
    useDeleteProspectingBatchByIdMutation = prospectingBatches.useDeleteProspectingBatchByIdMutation,
    usePutProspectingBatchDefaultProductByIdMutation = prospectingBatches.usePutProspectingBatchDefaultProductByIdMutation,
    usePutProspectingBatchMessagingByIdMutation = prospectingBatches.usePutProspectingBatchMessagingByIdMutation,
    useCreateProspectingBatchGiftsByIdMutation = prospectingBatches.useCreateProspectingBatchGiftsByIdMutation,
    useUploadProspectingContactsFileMutation = prospectingBatches.useUploadProspectingContactsFileMutation,
    useCreateProspectingBatchMutation = prospectingBatches.useCreateProspectingBatchMutation,
    usePutSendProspectingBatchByIdMutation = prospectingBatches.usePutSendProspectingBatchByIdMutation,
    usePutScheduleProspectingBatchByIdMutation = prospectingBatches.usePutScheduleProspectingBatchByIdMutation,
    usePutSendAsProspectingBatchByIdMutation = prospectingBatches.usePutSendAsProspectingBatchByIdMutation;
exports.usePutSendAsProspectingBatchByIdMutation = usePutSendAsProspectingBatchByIdMutation;
exports.usePutScheduleProspectingBatchByIdMutation = usePutScheduleProspectingBatchByIdMutation;
exports.usePutSendProspectingBatchByIdMutation = usePutSendProspectingBatchByIdMutation;
exports.useCreateProspectingBatchMutation = useCreateProspectingBatchMutation;
exports.useUploadProspectingContactsFileMutation = useUploadProspectingContactsFileMutation;
exports.useCreateProspectingBatchGiftsByIdMutation = useCreateProspectingBatchGiftsByIdMutation;
exports.usePutProspectingBatchMessagingByIdMutation = usePutProspectingBatchMessagingByIdMutation;
exports.usePutProspectingBatchDefaultProductByIdMutation = usePutProspectingBatchDefaultProductByIdMutation;
exports.useDeleteProspectingBatchByIdMutation = useDeleteProspectingBatchByIdMutation;
exports.useLazyGetProspectingContactsFileTemplateQuery = useLazyGetProspectingContactsFileTemplateQuery;
exports.useGetProspectingBatchEmailPreviewByIdQuery = useGetProspectingBatchEmailPreviewByIdQuery;
exports.useGetProspectingBatchStatusByIdQuery = useGetProspectingBatchStatusByIdQuery;
exports.useGetProspectingBatchGiftsByIdQuery = useGetProspectingBatchGiftsByIdQuery;
exports.useGetProspectingBatchByIdQuery = useGetProspectingBatchByIdQuery;
exports.useGetProspectingPartialBatchesQuery = useGetProspectingPartialBatchesQuery;